// deviceData.js — what The Web keeps in this browser, and clearing it.
// Signing out clears all of it, so the next person on a shared phone or
// laptop can't read the last person's birth details, saved people,
// reflections, pending invite or per-account flags. Reflections are copied
// to the account; saved people are not (Settings warns before clearing them).

export const LOCAL_PREFIXES = ["theweb.", "orb_formed_", "sat_activated_", "reveal_viewed_"];
export const SESSION_PREFIXES = ["theweb.", "revealed_"];

function clearPrefixed(store, prefixes) {
  try {
    const keys = [];
    for (let i = 0; i < store.length; i++) {
      const k = store.key(i);
      if (k && prefixes.some((p) => k.startsWith(p))) keys.push(k);
    }
    keys.forEach((k) => store.removeItem(k));
  } catch (e) { /* storage unavailable */ }
}

// Every key The Web keeps here, parsed where it's JSON. Used by the
// data download (dataExport.js).
function readPrefixed(store, prefixes) {
  const out = {};
  try {
    for (let i = 0; i < store.length; i++) {
      const k = store.key(i);
      if (!k || !prefixes.some((p) => k.startsWith(p))) continue;
      const raw = store.getItem(k);
      try { out[k] = JSON.parse(raw); } catch (e) { out[k] = raw; }
    }
  } catch (e) { /* storage unavailable */ }
  return out;
}

export function readDeviceData() {
  let local = {};
  let session = {};
  try { local = readPrefixed(window.localStorage, LOCAL_PREFIXES); } catch (e) { /* storage unavailable */ }
  try { session = readPrefixed(window.sessionStorage, SESSION_PREFIXES); } catch (e) { /* storage unavailable */ }
  return { localStorage: local, sessionStorage: session };
}

export function clearDeviceData() {
  try { clearPrefixed(window.localStorage, LOCAL_PREFIXES); } catch (e) { /* storage unavailable */ }
  try { clearPrefixed(window.sessionStorage, SESSION_PREFIXES); } catch (e) { /* storage unavailable */ }
}
